// extracted by mini-css-extract-plugin
module.exports = {"slider_custom":"slider_slider_custom__Mt6zS"};